import type { BaseBlock } from "../DataModel.types";
import type { TreeItem } from "./LayersTreeItem";

const findAllChildren = (
  blockProps: unknown,
  visited = new WeakSet(),
): BaseBlock[] => {
  const allChildren: BaseBlock[] = [];

  if (
    !blockProps ||
    typeof blockProps !== "object" ||
    visited.has(blockProps)
  ) {
    return allChildren;
  }

  visited.add(blockProps);

  Object.values(blockProps).forEach((prop: unknown) => {
    if (
      prop &&
      typeof prop === "object" &&
      "type" in prop &&
      "value" in prop &&
      prop.type === "children" &&
      Array.isArray(prop.value)
    ) {
      allChildren.push(...(prop.value as BaseBlock[]));
    } else if (prop && typeof prop === "object") {
      allChildren.push(...findAllChildren(prop, visited));
    }
  });

  return allChildren;
};

export const convertBlocksToTree = (blocks: BaseBlock[]): TreeItem[] =>
  blocks.map(block => {
    const treeItem: TreeItem = {
      id: block.id,
      type: block.type,
      collapsed: true,
    };

    const childBlocks = findAllChildren(block.props);
    if (childBlocks.length > 0) {
      treeItem.children = convertBlocksToTree(childBlocks);
    }

    return treeItem;
  });
